import React from 'react';
import { AppGridLayout, AppTableSearch, AppSearchItem, AppTable, AppRow, AppButton } from 'qcc';
import { AppAction, AppGridBar } from 'qcc';
import PosBankEditForm from './PosBankEditForm'
import PosBankSetForm from './PosBankSetForm'
import api from "api";

export default class extends React.Component {
  state = {}

  edit = async (data?: any) => {
    let title = '编辑入账银行';
    let editForm = <PosBankEditForm mode={1} formData={{ ...data }} />
    AppAction.openDialog(editForm, { title });
  }

  setting = (data?: any) => {
    let title = '设置入账银行';
    let editForm = <PosBankSetForm mode={1} formData={{ ...data }} />
    AppAction.openDialog(editForm, { title });
  }

  afterSave = () => {
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    AppAction.closeDialog();
  }

  upDatePosBank = async (data?: any) => {
    await api.posbank.upDatePosBank({ 'id': data.id, 'isOn': data.is_on });
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
  }

  getBanksByProjectId = async () => {
    let projectId = 0;
    if (this.refTableSearch.current)
      projectId = (this.refTableSearch.current.state.data.projectId) || 0;
    if (projectId === 0) return;
    await api.posbank.getBanksByProjectId({ projectId });
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
  }


  refGrid = React.createRef<AppGridLayout>();
  refTableSearch = React.createRef<AppTableSearch>();

  renderAction = (data?: any) => {
    if (data.is_on !== 0) {
      return (<AppRow itemSplit={10} style={{ float: 'right', marginRight: 10 }}>
        <AppButton type='link' label='禁用' actionCode="66200602" action={() => this.upDatePosBank(data)} />
      </AppRow>
      )
    } else {
      return (<AppRow itemSplit={10} style={{ float: 'right', marginRight: 10 }}>
        <AppButton type='link' label='启用' actionCode="66200602" action={() => this.upDatePosBank(data)} />
      </AppRow>);
    }
  }

  render() {
    return (
      <AppGridLayout ref={this.refGrid}>
        <AppGridLayout.SearchArea>
          <AppTableSearch ref={this.refTableSearch}>
            <AppTableSearch.Common>
              <AppSearchItem.ProjectTree keyName='projectId' projectTreeScene={6601} field='project_id' lable='项目：' />
            </AppTableSearch.Common>
          </AppTableSearch>
        </AppGridLayout.SearchArea>
        <AppGridLayout.MenuArea>
          <AppGridBar>
            <AppGridBar.Right>
              <AppButton label='同步入账银行' actionCode="66200601" type='primary' action={this.getBanksByProjectId} />
            </AppGridBar.Right>
          </AppGridBar>
        </AppGridLayout.MenuArea>
        <AppGridLayout.GridArea>
          <AppTable paging sqlId='sql.pos.bankGrid' onBeforeApi={(data?: any) => { return data.projectId !== undefined }}  >
            <AppTable.ColIndex />
            <AppTable.Col title='入账银行' field='zbanka' width={300} />
            <AppTable.Col title='银行账号' field='bankn' width={300} />
            <AppTable.Col title='款项名称' field='fundname' width={300} />
            <AppTable.Col title='分期' field='fqname' width={300} />
            <AppTable.Col title='对应楼栋' field='ldname' width={300} />
            <AppTable.Col title='备注' field='remark' width={300} />
            <AppTable.ColAction render={(data: any, dataIndex: number) => {
              return this.renderAction(data)
            }} />
          </AppTable>
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/pos/bank/PosBankGird.tsx